// src/utils/validation.js
/**
 * Checks a password against a set of strength requirements.
 *
 * @param {string} password - The password to validate.
 * @returns {object} An object indicating the status of each requirement and overall validity.
 *                   Example: { minLength: true, lowercase: true, uppercase: false, ... isValid: false }
 */
export const getPasswordValidationState = (password) => {
    const requirements = {
      minLength: password.length >= 8,
      lowercase: /[a-z]/.test(password),
      uppercase: /[A-Z]/.test(password),
      number: /[0-9]/.test(password),
      specialChar: /[^a-zA-Z0-9\s]/.test(password), // Check for non-alphanumeric, non-whitespace
    };
  
    // Check if all requirements are met
    const isValid = Object.values(requirements).every(Boolean);
  
    return {
      ...requirements,
      isValid,
    };
  };
  
  /**
   * Provides user-friendly descriptions for each password requirement key.
   */
  export const passwordRequirementDescriptions = {
    minLength: "At least 8 characters long",
    lowercase: "At least one lowercase letter (a-z)",
    uppercase: "At least one uppercase letter (A-Z)",
    number: "At least one number (0-9)",
    specialChar: "At least one special character (!@#$%^&*)",
  };